import {
  Component,
  OnInit,
  ViewChildren,
  QueryList,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatPaginator, MatSort, MatTableDataSource } from "@angular/material";
import { environment } from 'environments/environment';

@Component({
  selector: "app-fondo-inversion",
  templateUrl: "./fondo-inversion.component.html",
  styleUrls: ["./fondo-inversion.component.scss"],
})
export class FondoInversionComponent implements OnInit {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();

  pageSizeOptsFIEGen = [15, 20, 30, 50, 100, 200];
  pageSizeOptsFIExEstado = [15, 20, 30, 50, 100, 200];
  pageSizeOptsIFxEstado = [15, 20, 30, 50, 100, 200];
  pageSizeOptsFNReprogFIE = [15, 20, 30, 50, 100, 200];
  pageSizeOptsFNReprogIF = [15, 20, 30, 50, 100, 200];

  displColsFIEGen = [
    "CodValorCAVALI",
    "RegEnCAVALI",
    "Numero",
    "RUCAdq",
    "RazonSocialAdq",
    "Sector",
    "GrupoEmpresaMatriz",
    "Ranking",
    "RUCProv",
    "RazonSocialProv",
    "ValVenta",
    "FPago",
    "Reprogramacion",
    "MontoNeto",
  ];
  displColsFIExEstado = ["Estado", "Cantidad", "SumaVNPP", "Porcentaje"];
  displColsIFxEstado = ["Estado", "Cuenta", "SumaVNPP", "Porcentaje"];

  facturasFIEGen: any = [];
  facturasFIExEstado: any = [];
  facturasIFxEstado: any = [];
  facturasFNReprogFIE: any = [];
  facturasFNReprogIF: any = [];

  dSourceFIEGen: any;
  dSourceFIExEstado: any;
  dSourceIFxEstado: any;
  dSourceFNReprogFIE: any;
  dSourceFNReprogIF: any;

  loading: boolean;
  filterValues = { Moneda: "", Estado: "", EstadoReprog: "" };
  monedaFilter = new FormControl("");
  estadoFilter = new FormControl("");
  estadoReprogFilter = new FormControl("");

  constructor() {
    this.obtenerFacturasFIEGeneral();
    this.obtenerFacturasFIExEstado();
    this.obtenerFacturasIFxEstado();
    this.obtenerFacturasFNReprogFIE();
    this.obtenerFacturasFNReprogIF();
  }

  ngOnInit() {
    this.monedaFilter.valueChanges.subscribe((Moneda) => {
      this.filterValues.Moneda = Moneda;
      this.dSourceFIEGen.filter = JSON.stringify(this.filterValues);
    });

  }
  createFilter(): (data: any, filter: string) => boolean {
    return function (data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return (
        data.Moneda.toString().toLowerCase().indexOf(searchTerms.Moneda) !== -1
      );
    };
  }

  obtenerFacturasFIEGeneral() {
    this.loading = true;

    setTimeout(() => {
      this.facturasFIEGen = [
        {
          CodValorCAVALI: "FN0000385814",
          RegEnCAVALI: "2019-10-31 00:00:00",
          Numero: "E001-000037",
          RUCAdq: "20100083362",
          RazonSocialAdq: "CORPORACION SAPIA S.A.",
          Sector: "TELECOMUNICACIONES",
          GrupoEmpresaMatriz: "CORPORACION SAPIA S.A.",
          Ranking: "755",
          RUCProv: "20602573720",
          RazonSocialProv: "SALAS MEJIA TELECOM S.A.C.",
          ValVenta: "7434",
          FPago: "2020-01-03 00:00:00",
          Reprogramacion: "2020-01-03 00:00:00",
          MontoNeto: "7434",
          Moneda: "SOLES",
          Estado: "VIGENTE",
        },
        {
          CodValorCAVALI: "FN0000385815",
          RegEnCAVALI: "2019-10-31 00:00:00",
          Numero: "E001-000036",
          RUCAdq: "20100083362",
          RazonSocialAdq: "CORPORACION SAPIA S.A.",
          Sector: "TELECOMUNICACIONES",
          GrupoEmpresaMatriz: "CORPORACION SAPIA S.A.",
          Ranking: "755",
          RUCProv: "20602573720",
          RazonSocialProv: "SALAS MEJIA TELECOM S.A.C.",
          ValVenta: "7434",
          FPago: "2020-01-03 00:00:00",
          Reprogramacion: "2020-01-03 00:00:00",
          MontoNeto: "7434",
          Moneda: "SOLES",
          Estado: "MORA",
        },
        {
          CodValorCAVALI: "FN0000385816",
          RegEnCAVALI: "2019-10-31 00:00:00",
          Numero: "E001-000035",
          RUCAdq: "20100083362",
          RazonSocialAdq: "CORPORACION SAPIA S.A.",
          Sector: "TELECOMUNICACIONES",
          GrupoEmpresaMatriz: "CORPORACION SAPIA S.A.",
          Ranking: "755",
          RUCProv: "20602573720",
          RazonSocialProv: "SALAS MEJIA TELECOM S.A.C.",
          ValVenta: "5841",
          FPago: "2020-01-03 00:00:00",
          Reprogramacion: "2020-01-03 00:00:00",
          MontoNeto: "5140",
          Moneda: "DOLARES",
          Estado: "VIGENTE",
        },
      ];
      this.dSourceFIEGen = new MatTableDataSource(this.facturasFIEGen);
      this.dSourceFIEGen.sort = this.sort.toArray()[0];
      this.dSourceFIEGen.paginator = this.paginator.toArray()[0];
      this.dSourceFIEGen.filterPredicate = this.createFilter();

      this.loading = false;
    }, 2000);
  }

  obtenerFacturasFIExEstado() {
    this.loading = true;

    setTimeout(() => {
      this.facturasFIExEstado = [
        {
          Estado: "Mora",
          Cantidad: "221",
          SumaVNPP: "2769384",
          Porcentaje: "51",
        },
        {
          Estado: "Vigente",
          Cantidad: "210",
          SumaVNPP: "3784018",
          Porcentaje: "49",
        },
      ];

      this.dSourceFIExEstado = new MatTableDataSource(this.facturasFIExEstado);
      this.dSourceFIExEstado.sort = this.sort.toArray()[1];
      this.dSourceFIExEstado.paginator = this.paginator.toArray()[1];
      this.dSourceFIExEstado.filterPredicate = this.createFilter();

      this.loading = false;
    }, 2000);
  }

  obtenerFacturasIFxEstado() {
    this.loading = true;

    setTimeout(() => {
      this.facturasIFxEstado = [
        {
          Estado: "Mora",
          Cuenta: "94",
          SumaVNPP: "1405915",
          Porcentaje: "27",
        },
        {
          Estado: "Vigente",
          Cuenta: "205",
          SumaVNPP: "37140822",
          Porcentaje: "73",
        },
      ];

      this.dSourceIFxEstado = new MatTableDataSource(this.facturasIFxEstado);
      this.dSourceIFxEstado.sort = this.sort.toArray()[2];
      this.dSourceIFxEstado.paginator = this.paginator.toArray()[2];
      this.dSourceIFxEstado.filterPredicate = this.createFilter();

      this.loading = false;
    }, 2000);
  }

  obtenerFacturasFNReprogFIE() {
    this.loading = true;

    setTimeout(() => {
      this.facturasFNReprogFIE = [{}, {}];

      this.dSourceFNReprogFIE = new MatTableDataSource(
        this.facturasFNReprogFIE
      );
      this.dSourceFNReprogFIE.sort = this.sort.toArray()[3];
      this.dSourceFNReprogFIE.paginator = this.paginator.toArray()[3];
      this.dSourceFNReprogFIE.filterPredicate = this.createFilter();

      this.loading = false;
    }, 2000);
  }

  obtenerFacturasFNReprogIF() {
    this.loading = true;

    setTimeout(() => {
      this.facturasFNReprogIF = [{}, {}];

      this.dSourceFNReprogIF = new MatTableDataSource(this.facturasFNReprogIF);
      this.dSourceFNReprogIF.sort = this.sort.toArray()[4];
      this.dSourceFNReprogIF.paginator = this.paginator.toArray()[4];
      this.dSourceFNReprogIF.filterPredicate = this.createFilter();

      this.loading = false;
    }, 2000);
  }
}
